// // src/contexts/KurseContext.js
import React, { createContext, useContext, useRef, useState, useCallback } from "react";
import { fetchWithRetry } from "../utils/fetchWithRetry";

const KurseContext = createContext();

export const KurseProvider = ({ children }) => {
  const [kurse, setKurse] = useState([]);
  const [loadingKurse, setLoadingKurse] = useState(false);
  const [errorKurse, setErrorKurse] = useState(null);

  const today = new Date().toISOString().split('T')[0];
  const inFlightRef = useRef(null);
  const loadedRef = useRef(false);

  const fetchKurse = useCallback(async () => {
    if (loadedRef.current && !errorKurse) return;
    if (inFlightRef.current) return inFlightRef.current;

    setLoadingKurse(true); setErrorKurse(null);
    const ac = new AbortController();

    const url = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Kurse?fields=*.*.*.*,*.*.*.Fuehrerscheine_id.*&filter[status][_eq]=published&filter[Ende][_gte]=${today}&sort=Start&limit=1000`;

    const p = (async () => {
      try {
        const res = await fetchWithRetry(
          () => fetch(url, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        if (!res.ok) throw new Error(`Fehler HTTP: ${res.status}`);
        const data = await res.json();
        setKurse(data?.data ?? []);
        loadedRef.current = true;
      } catch (e) {
        if (!ac.signal.aborted) setErrorKurse(e.message || "Fehler beim Laden der Kurse");
      } finally {
        if (!ac.signal.aborted) setLoadingKurse(false);
        inFlightRef.current = null;
      }
    })();

    inFlightRef.current = p;
    return p;
  }, [today, errorKurse]);

  return (
    <KurseContext.Provider value={{ kurse, loadingKurse, errorKurse, fetchKurse }}>
      {children}
    </KurseContext.Provider>
  );
};

export const useKurse = () => useContext(KurseContext);
